import { render, staticRenderFns } from "./customer-basic.vue?vue&type=template&id=0c7e1716&scoped=true&"
import script from "./customer-basic.vue?vue&type=script&lang=js&"
export * from "./customer-basic.vue?vue&type=script&lang=js&"
import style0 from "./customer-basic.vue?vue&type=style&index=0&id=0c7e1716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7e1716",
  null
  
)

export default component.exports